module.exports = __webpack_public_path__ + "img/bancontact.44b48e8d.png";